import createIcon from '../../createIcon';

/**
 * @component @name LocalPizza
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTk5OCAyQzguNDI5NzcgMiA1LjIyOTc3IDMuNTQgMy4wMDk3NyA2TDExLjk5OTggMjJMMjAuOTg5OCA2QzE4Ljc3OTggMy41NSAxNS41Njk4IDIgMTEuOTk5OCAyWk02Ljk5OTc3IDdDNi45OTk3NyA1LjkgNy44OTk3NyA1IDguOTk5NzcgNUMxMC4wOTk4IDUgMTAuOTk5OCA1LjkgMTAuOTk5OCA3QzEwLjk5OTggOC4xIDEwLjA5OTggOSA4Ljk5OTc3IDlDNy44OTk3NyA5IDYuOTk5NzcgOC4xIDYuOTk5NzcgN1pNMTEuOTk5OCAxNUMxMC44OTk4IDE1IDkuOTk5NzcgMTQuMSA5Ljk5OTc3IDEzQzkuOTk5NzcgMTEuOSAxMC44OTk4IDExIDExLjk5OTggMTFDMTMuMDk5OCAxMSAxMy45OTk4IDExLjkgMTMuOTk5OCAxM0MxMy45OTk4IDE0LjEgMTMuMDk5OCAxNSAxMS45OTk4IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalPizza = createIcon('LocalPizza', [
  [
    'path',
    {
      d: 'M11.9998 2C8.42977 2 5.22977 3.54 3.00977 6L11.9998 22L20.9898 6C18.7798 3.55 15.5698 2 11.9998 2ZM6.99977 7C6.99977 5.9 7.89977 5 8.99977 5C10.0998 5 10.9998 5.9 10.9998 7C10.9998 8.1 10.0998 9 8.99977 9C7.89977 9 6.99977 8.1 6.99977 7ZM11.9998 15C10.8998 15 9.99977 14.1 9.99977 13C9.99977 11.9 10.8998 11 11.9998 11C13.0998 11 13.9998 11.9 13.9998 13C13.9998 14.1 13.0998 15 11.9998 15Z',
      key: 'fmrp1l',
    },
  ],
]);

export default LocalPizza;
